__turbopack_context__.v({
  "count": "styles-module-scss-module__4l3J6q__count",
  "rolling": "styles-module-scss-module__4l3J6q__rolling",
});
